import { defineStore } from 'pinia'
import axios from 'axios'
import { useAuthStore } from '@/auth/auth'
import { ApiSup } from "@/Functions/ApiSupport";

export const useParentStore = defineStore('parentStore', {
  state: () => ({
    parents: [],
    approved: [],
    forApproval: [],
    parentInfo: {}
  }),
  actions: {

    async getInfo(pid){
      const apiSup = ApiSup()
      const ret = await apiSup.getSupport('api/parents/' + pid)

      this.parentInfo = ret
    },

   async updateAddress(pid, body){
    const apiSup = ApiSup()
    const ret = apiSup.putSupport('api/parents/' + pid, body)
    this.getInfo(pid)
    return ret

   },

    async fetchForApprovalWithSchoolId(pid) {
      const authStore = useAuthStore()
      if (pid !== '') {
        const res = await fetch(
          `${import.meta.env.VITE_HOST_API}/api/schools/` + pid + `/users/approval`,
          {
            headers: {
              Authorization: `Bearer ${authStore.token}`,
            },
          },
        )
        const data = await res.json()
        this.forApproval = data.users
      }
    },

    async fetchApproveWithSchoolID(pid) {
      const authStore = useAuthStore()
      if (pid !== '') {
        const res = await fetch(
          `${import.meta.env.VITE_HOST_API}/api/schools/` + pid + `/users/approved/inactive`,{
            headers:{
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )
        const data = await res.json()
        this.approved = data.users
      }
    },
    async fetchActivatedWithSchoolID(pid) {
      const authStore = useAuthStore()
      if (pid !== '') {
        const res = await fetch(
          `${import.meta.env.VITE_HOST_API}/api/schools/` + pid + `/users/approved/active`,{
            headers:{
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )
        const data = await res.json()
        this.parents = data.users
      }
    },

    async approvedParent(pid) {
      const authStore = useAuthStore()
      try {
        const res = await fetch(
          `${import.meta.env.VITE_HOST_API}/api/students/parents/approve/` + pid,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authStore.token}`,
            },
            body: JSON.stringify({ signature: authStore.hashText('') }),
          },
        )

        if (!res.ok) throw new Error(`Failed with status ${res.status}`)
        const data = await res.json()

        this.fetchForApproval()
        this.fetchApproved()
        this.fetchActivated()
        return data.status
      } catch (error) {
        console.error('Approval failed:', error)
        return null
      }
    },

    async fetchForApproval() {
      const authStore = useAuthStore()
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/students/parents/approval`,{
        headers:{
          Authorization: `Bearer ${authStore.token}`,
        }
      })
      const data = await res.json()
      this.forApproval = data.users
    },

    async fetchApproved() {
      const authStore = useAuthStore()
      const res = await fetch(
        `${import.meta.env.VITE_HOST_API}/api/students/parents/approved/inactive`,{
          headers:{
            Authorization: `Bearer ${authStore.token}`,
          }
        }
      )
      const data = await res.json()
      this.approved = data.users
    },
    async fetchActivated() {
      const authStore = useAuthStore()
      const res = await fetch(
        `${import.meta.env.VITE_HOST_API}/api/students/parents/approved/active`,{
          headers:{
            Authorization: `Bearer ${authStore.token}`,
          }
        }
      )
      const data = await res.json()
      this.parents = data.users
    },
  },
})
